mutation SetLicensesForUser($input: SetLicensesForUserInput!) {
    setLicensesForUser(input: $input) {
        licenseUpdateResponse {
            wasSuccessful
            errorMessage
            newLicenseState
        }
    }
}
